module.exports = __webpack_public_path__ + "static/media/IMG_3872.c339a769.jpg";